var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"m-4 space-y-4 p-6 md:w-1/2"},[_c('div',{staticClass:"space-y-6 text-center"},[_c('OutlineInformationCircleIcon',{staticClass:"mx-auto h-20 w-20 text-gray-300"}),_c('p',{staticClass:"text-2xl font-bold text-gray-300"},[_vm._v(_vm._s(_vm.msg))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }